import React from 'react';
import { t, tf } from '../i18n';

// Validate areas[]: returns { errors: string[], rowErrors: { [idx]: string } }.
// Empty rows (everything blank) are ignored — they're "in-progress" not invalid.
export function validateAreas(areas, cfg, locale) {
    var qtyMin = cfg.qtyMin || 1;
    var qtyMax = cfg.qtyMax || 200;
    var prefixOptional = !!cfg.prefixOptional;
    var L = {
        emptyArea: t(locale, 'p_area_name_required'),
        prefixRequired: t(locale, 'p_prefix_required'),
        invalidStart: t(locale, 'p_start_min'),
        invalidEnd: t(locale, 'p_end_min'),
        countRange: tf(locale, 'p_count_range', { min: qtyMin, max: qtyMax }),
        overlap: t(locale, 'p_range_overlap'),
        noValidRow: t(locale, 'areas_need_valid')
    };

    var rowErrors = {};
    var errors = [];
    var validRows = [];

    areas.forEach(function (a, idx) {
        var areaName = String(a.area_name || '').trim();
        var prefix = String(a.prefix || '').trim();
        var startStr = String(a.start_no == null ? '' : a.start_no).trim();
        var endStr = String(a.end_no == null ? '' : a.end_no).trim();

        if (!areaName && !prefix && !startStr && !endStr) return;

        // if (!areaName) { rowErrors[idx] = L.emptyArea; return; }
        // if (!prefixOptional && !prefix) { rowErrors[idx] = L.prefixRequired; return; }

        var start = parseInt(startStr, 10);
        var end = parseInt(endStr, 10);
        if (!Number.isFinite(start) || start < 1) { rowErrors[idx] = L.invalidStart; return; }
        if (!Number.isFinite(end) || end < start) { rowErrors[idx] = L.invalidEnd; return; }

        var count = end - start + 1;
        if (count < qtyMin || count > qtyMax) { rowErrors[idx] = L.countRange; return; }

        validRows.push({ idx: idx, areaName: areaName, prefix: prefix, start: start, end: end });
    });

    for (var i = 0; i < validRows.length; i++) {
        for (var j = i + 1; j < validRows.length; j++) {
            var aa = validRows[i], bb = validRows[j];
            if (aa.prefix !== bb.prefix) continue;
            if (aa.start <= bb.end && bb.start <= aa.end) {
                if (!rowErrors[aa.idx]) rowErrors[aa.idx] = L.overlap;
                if (!rowErrors[bb.idx]) rowErrors[bb.idx] = L.overlap;
            }
        }
    }

    if (validRows.length === 0 && Object.keys(rowErrors).length === 0) {
        errors.push(L.noValidRow);
    }
    if (Object.keys(rowErrors).length > 0) {
        Object.keys(rowErrors).forEach(function (k) {
            var msg = rowErrors[k];
            if (errors.indexOf(msg) === -1) errors.push(msg);
        });
    }

    return { errors: errors, rowErrors: rowErrors, validCount: validRows.length };
}

export default function AreaListPanel(props) {
    var locale = props.locale || 'vi';
    var cfg = props.config || {};
    var areas = (props.value && props.value.areas) || [];
    var qtyMin = cfg.qtyMin || 1;
    var qtyMax = cfg.qtyMax || 200;
    var minAreas = cfg.minAreas || 1;
    var maxAreas = cfg.maxAreas || 10;
    var prefixOptional = !!cfg.prefixOptional;

    function update(idx, key, val) {
        var next = areas.map(function (a, i) {
            return i === idx ? Object.assign({}, a, { [key]: val }) : a;
        });
        props.onChange({ areas: next });
    }
    function add() {
        var n = areas.length + 1;
        var next = areas.concat([{ area_name: '', prefix: '', start_no: '', end_no: '' }]);
        next[next.length - 1].area_name = tf(locale, 'p_zone_n', { n: n });
        props.onChange({ areas: next });
    }
    function remove(idx) {
        if (areas.length <= minAreas) return;
        props.onChange({ areas: areas.filter(function (_, i) { return i !== idx; }) });
    }

    var labelArea = (cfg.label_area && (cfg.label_area[locale] || cfg.label_area.en || cfg.label_area.vi)) || t(locale, 'p_area');
    var labelPrefix = (cfg.label_prefix && (cfg.label_prefix[locale] || cfg.label_prefix.en || cfg.label_prefix.vi)) || t(locale, 'p_prefix');
    var labelStart = (cfg.label_start && (cfg.label_start[locale] || cfg.label_start.en || cfg.label_start.vi)) || t(locale, 'p_start');
    var labelEnd = (cfg.label_end && (cfg.label_end[locale] || cfg.label_end.en || cfg.label_end.vi)) || t(locale, 'p_end');
    var labelCount = (cfg.label_count && (cfg.label_count[locale] || cfg.label_count.en || cfg.label_count.vi)) || t(locale, 'p_count');

    var v = validateAreas(areas, cfg, locale);
    var totalCount = areas.reduce(function (s, a) {
        var st = parseInt(a.start_no, 10);
        var en = parseInt(a.end_no, 10);
        if (Number.isFinite(st) && Number.isFinite(en) && en >= st) return s + (en - st + 1);
        return s;
    }, 0);

    return (
        <div className="wiz-areas">
            <div className="wiz-areas__head">
                <span>{labelArea}</span>
                <span>{labelPrefix}{prefixOptional ? '' : ' *'}</span>
                <span>{labelStart}</span>
                <span>{labelEnd}</span>
                <span>{labelCount}</span>
                <span></span>
            </div>
            {areas.map(function (a, idx) {
                var st = parseInt(a.start_no, 10);
                var en = parseInt(a.end_no, 10);
                var rowCount = (Number.isFinite(st) && Number.isFinite(en) && en >= st) ? (en - st + 1) : '—';
                var rowErr = v.rowErrors[idx];
                return (
                    <div className={'wiz-areas__row' + (rowErr ? ' wiz-areas__row--err' : '')} key={idx}>
                        <input
                            className="wiz-areas__input"
                            value={a.area_name || ''}
                            onChange={function (e) { update(idx, 'area_name', e.target.value); }}
                        />
                        <input
                            className="wiz-areas__input"
                            value={a.prefix || ''}
                            placeholder={prefixOptional ? t(locale, 'p_none') : ''}
                            onChange={function (e) { update(idx, 'prefix', e.target.value.toUpperCase()); }}
                        />
                        <input
                            className="wiz-areas__input wiz-areas__input--num"
                            type="number"
                            min={1}
                            value={a.start_no === undefined || a.start_no === null ? '' : a.start_no}
                            onChange={function (e) { update(idx, 'start_no', e.target.value); }}
                        />
                        <input
                            className="wiz-areas__input wiz-areas__input--num"
                            type="number"
                            min={1}
                            value={a.end_no === undefined || a.end_no === null ? '' : a.end_no}
                            onChange={function (e) { update(idx, 'end_no', e.target.value); }}
                        />
                        <span className="wiz-areas__count">{rowCount}</span>
                        <button
                            type="button"
                            className="wiz-areas__remove"
                            disabled={areas.length <= minAreas}
                            onClick={function () { remove(idx); }}
                        >×</button>
                        {rowErr ? <div className="wiz-areas__rowerr">{rowErr}</div> : null}
                    </div>
                );
            })}
            {areas.length < maxAreas ? (
                <button type="button" className="wiz-areas__add" onClick={add}>
                    + {t(locale, 'p_add_row')}
                </button>
            ) : null}
            <div className="wiz-areas__total">
                {t(locale, 'p_total')}: <strong>{totalCount}</strong>
                {' '}({tf(locale, 'p_min_max', { min: qtyMin, max: qtyMax })})
            </div>
        </div>
    );
}
